module.exports = __webpack_public_path__ + "img/wavdata_card_image.919eb024.jpeg";